import * as allExports from "@react-aria/focus";
const { FocusScope } = allExports;
export { FocusScope };
//# sourceMappingURL=main.entry.mjs.mjs.map